export default function FeaturesSection() {
  const features = [
    {
      title: "The Snow",
      image: "/images/MOM-poster.png",
      description:
        "Whether you're a seasoned skier or finding your footing, Beijing has something for everyone. Boasting Asia's largest skiable glacier and an impressive network of pistes, the resort's altitude ensures superb snow-sport conditions.",
      cta: "EXPLORE THE SLOPES",
      color: "blue",
    },
    {
      title: "The Music",
      image: "/images/MOM-poster.png",
      description:
        "We bring an incredible lineup of world-class artists—ranging from Grammy nominees to platinum-selling acts—performing on stunning stages set against the breathtaking backdrop of the mountains.",
      cta: "DISCOVER THE LINEUP",
      color: "yellow",
    },
    {
      title: "The Adventure",
      image: "/images/MOM-poster.png",
      description:
        "Beyond the slopes, SoFest is a hub of adventure. From authentic Chinese fondues to adrenaline filled paragliding, SoFest takes you beyond just skiing or snowboarding. Our festival offers something for everyone!",
      cta: "SEE ACTIVITIES",
      color: "red",
    },
  ];

  return (
    <section className="tw-py-16 tw-px-4 tw-bg-gray-50" id="explore">
      <div className="tw-max-w-7xl tw-mx-auto">
        <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-gap-8">
          {features.map((feature, index) => (
            <div key={index} className="tw-relative">
              <div
                className={`tw-absolute tw-inset-0 tw-bg-${feature.color}-100 tw-transform tw-rotate-1 tw-rounded-lg tw--z-10`}
              ></div>
              <div className="tw-bg-white tw-rounded-lg tw-overflow-hidden tw-shadow-md">
                <div className="tw-relative">
                  <img
                    src={feature.image || "/placeholder.svg"}
                    alt={feature.title}
                    className="tw-w-full tw-h-64 tw-object-cover"
                  />
                </div>
                <div className="tw-p-6">
                  <h3 className="tw-text-2xl tw-font-bold tw-mb-4">
                    {feature.title}
                  </h3>
                  <p className="tw-text-gray-700 tw-mb-6">
                    {feature.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
